import {LocalStorageService} from "./local-storage-service";

const getConfig = () => {
    return window.AppSettings
}

const getRisTitle = () => {
    return window?.AppSettings?.ris?.title[LocalStorageService.getLanguage('tr')]
}

const AppConfig = {
    getConfig,
    getRisTitle
}

export default AppConfig;